import { useState, useEffect } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import styled from 'styled-components';

import ClientsNavBar from './components/ClientsNavBar.jsx';
import { ClientsDashboard } from './components/ClientsDashboard/index.jsx';
import { Fetcher } from '../../lib/helpers';
import TabNavigation from '../../shared/TabNavigation';

const ClientAdminClients = () => {
  const [templateList, setTemplateList] = useState([]);
  const getVbfTemplates = () => {
    Fetcher.get('/api/client_admin/campaigns/template_boards', response =>
      setTemplateList(response.templates),
    );
  };
  const tabs = [
    { name: 'Active', to: '/', exact: true },
    { name: 'Archived', to: 'archived' },
  ];

  useEffect(() => {
    getVbfTemplates();
  }, []);

  const RouterContent = () => {
    return (
      <>
        <TopBar>
          <TabNavigation tabs={tabs} />
          <ClientsNavBar templateList={templateList} />
        </TopBar>

        <Switch>
          <Route exact path="/" component={ClientsDashboard} />
          <Route exact path="/archived" component={ClientsDashboard} />
        </Switch>
      </>
    );
  };

  return (
    <HashRouter hashType="noslash">
      <RouterContent />
    </HashRouter>
  );
};

export default ClientAdminClients;

const TopBar = styled.div`
  display: flex;
  padding: 24px 24px 0px;
  justify-content: space-between;
`;
